// src/components/project/SKIPER/PresentationPage.jsx
import React from 'react';
import '../../../styles/components/_PresentationPage.scss';

import Sidebar from './Sidebar';
import Prototipes from './chapters/Prototipes';
import Story from './chapters/Story';
import WhyAntarctica from './chapters/WhyAntarctica';

export default function PresentationPage() {
  return (
    <div className="presentation-page-container">
      {/* ----------------------------- */}
      {/*  1) COLUMNA DE CONTENIDO (izquierda/centro) */}
      {/* ----------------------------- */}
      <main className="presentation-content-area">
    
        <Story />   
        <WhyAntarctica />           
        <Prototipes />        
   
      </main>

      {/* ----------------------------- */}
      {/*  2) SIDEBAR (derecha) */}
      {/* ----------------------------- */}
      <aside className="presentation-sidebar">
        <Sidebar />
      </aside>
    </div>
  );
}
